import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, Box, Button, Column, Columns, ErrorBoundary, FlexBox, Page, Spinner, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { connect } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import { CustomizationPageSelectors } from '../../common/selectors';
import { DixaMessengerPanelForms } from '../Panel/messengerPanelForms';
import { CustomizationFormView } from './components/FollowupCustomizationForm';
import { CsatPreview } from './components/csatPreview/CsatPreview';
import { formatFormValuesFromCsatPreview } from './formatFormValuesForCsatPreview';
import styles from './index.module.scss';
const CustomizationPageView = ({ onSubmit, formValues, languageName, handleSubmit, error: errorMessage, isLoading, pristine, mode, }) => {
    const [previewLoaded, setPreviewLoaded] = useState(false);
    const previewIframeRef = useRef(null);
    useEffect(() => {
        const sendFormValuesOverToPreview = () => {
            var _a, _b;
            (_b = (_a = previewIframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({
                type: 'setCustomizationObject',
                payload: formatFormValuesFromCsatPreview(formValues),
            }, '*');
        };
        setTimeout(sendFormValuesOverToPreview, previewLoaded ? 0 : 1000);
    }, [formValues, previewLoaded]);
    const handlePreviewLoaded = useCallback(() => {
        if (!previewLoaded) {
            setTimeout(() => setPreviewLoaded(true));
        }
    }, [previewLoaded]);
    if (isLoading) {
        return (_jsx(FlexBox, Object.assign({ height: "100%", justifyContent: "center", alignItems: "center" }, { children: _jsx(Spinner, {}) })));
    }
    return (_jsxs(Page.Section, Object.assign({ title: languageName, controls: _jsx(Button, Object.assign({ disabled: mode === 'edit' && pristine, onClick: handleSubmit }, { children: "Save customization" })) }, { children: [errorMessage && (_jsx(Box, Object.assign({ margin: "0 0 400" }, { children: _jsx(Banner, { variant: "fail", icon: null, description: _jsx(_Fragment, { children: errorMessage }) }) }))), _jsx(Form, Object.assign({ onSubmit: handleSubmit((data) => {
                    setPreviewLoaded(false);
                    onSubmit(data);
                }) }, { children: _jsxs(Columns, { children: [_jsxs(Column, Object.assign({ size: "50%", className: styles.leftPane }, { children: [!previewLoaded && _jsx(Spinner, { className: styles.previewSpinner }), _jsx(ErrorBoundary, Object.assign({ fallback: _jsx("div", { children: "Something went wrong..." }) }, { children: _jsx(CsatPreview, { ref: previewIframeRef, onLoad: handlePreviewLoaded, className: !previewLoaded ? styles.leftPaneLoading : undefined }) }))] })), _jsx(Column, Object.assign({ size: "50%", className: styles.rightPane }, { children: _jsx(CustomizationFormView, {}) }))] }) }))] })));
};
export const CustomizationPageForm = reduxForm({
    form: DixaMessengerPanelForms.LanguageCustomizationPageForm,
    enableReinitialize: true,
})(CustomizationPageView);
export const CustomizationPage = connect((state, ownProps) => ({
    isLoading: state.settings.satisfaction.customization.messenger.languagesLevel
        .asyncStatus === 'loading',
    formValues: CustomizationPageSelectors.dixaMessengerLanguageCustomizationFormValuesgetter(state),
    initialValues: CustomizationPageSelectors.initialDixaMessengerValuesSelector(state, ownProps),
}))(CustomizationPageForm);
